<template>
  <div class="relogin-on-fly noHideSidebar">
    <div class="relogin-on-fly__ie-blur"></div>
    <ui-scrollbar>
    <div class="relogin-on-fly__content-wrapper">
      <!-- <div class="relogin-header">
        <div class="relogin-header__container">
          <div class="relogin-header__logo">
            <img class="relogin-header__logo-img" width="80" srcset="static/img/logo.png 1x, static/img/logo@2x.png 2x"  src="static/img/logo.png" :alt="$t('login.title')">
            <div class="relogin-header__logo-text">{{ $t('login.title') }}</div>
          </div>
        </div>
      </div> -->
      <div class="relogin-content">
        <div class="relogin-on-fly__inner">
          <!-- <div class="relogin-on-fly__notify">
            <div class="relogin-on-fly__icon">
              <img src="static/img/lock.svg" alt="icon">
            </div>
            {{ $t('login.relogin.description') }}
          </div> -->
          <div class="relogin-on-fly__alert" :class="alertType" v-if="alertText">
            {{alertText}}
          </div>
          <div class="relogin-on-fly__form-container">
            <LangCheck class="relogin-on-fly__lang-check" :need-confirm-on-change="false" />
            <div class="login-page-form__logo">
              <a :href="clientLink">
                <picture>
                  <source id="s4" :srcset="logoSrcDefault" type="image/svg">
                  <img :src="logoSrc" alt="" onerror="this.src=document.getElementById('s4').srcset;">
                </picture>
              </a>
            </div>
            <div class="relogin-on-fly__legend" v-if="!showLoginHelp">
              <div
                v-if="validationError"
                class="login-page-form__error"
              >
                {{ validationError }}
              </div>
              <template v-else>
                <span class="relogin-on-fly__legend-title">{{$t('login.enter_to')}}</span>
                <!-- src="static/img/login_type3.svg" -->
                <img
                  :src="loginTypeSrc"
                  class="client_logo"
                >
                <span class="client_text">{{ loginTypeText }}</span>
                <!-- <span>{{ $t('login.employees_login') }}</span> -->
                <!-- <span v-else class="relogin-on-fly__notification">{{ notificationText }}</span> -->
              </template>
            </div>
            <authenticate
              @login-success="onLoginSuccess"
              @login-error="onLoginError"
              @login-canceled="onLoginCancel"
              @getError="showError"
              @recoveryCodeSended="onRecoveryCodeSended"
              @passwordChanged="onPasswordChanged"
              @showCreateAcc="onShowCreateAcc"
              @showForgotPassword="onShowForgotPassword"
              :show-cancel="false"
              :createAccInfo="showLoginHelp"
              :createAccText="createAccText"
            >
            </authenticate>
            <div class="login-page-form__create-account" v-if="showLoginHelp">
              <div
                class="login-page-form__help-login-text"
                @click.prevent="showLoginHelp = !showLoginHelp"
                v-if="showLoginHelp"
              >
                <span>{{ $t('login.enter_system') }}</span>
              </div>
              <!-- <a href="/" class="login-page-form__enterby" v-else>
                <span>{{ $t('login.enterby') }}</span>
                <img src="static/img/logos/gos_logo.svg" :alt="$t('login.gos_uslugi')">
              </a> -->
            </div>
          </div>
        </div>
      </div>
      <div class="relogin-footer">
        <div class="relogin-footer__wrapper">
          <div class="relogin-footer__container">
            <a :href="clientLink"  target="_blank" class="relogin-footer__logo">
              <picture>
                <source id="s5" :srcset="footerLogoSrcDefault" type="image/svg">
                <img :src="footerLogoSrc" alt="" onerror="this.src=document.getElementById('s5').srcset;">
              </picture>
            </a>
            <div class="relogin-footer__text">{{ $t('login.universallogin') }}</div>
            <a href="https://lionsdigital.pro" class="relogin-footer__logo-ldp" target="_blank">
             <div class="relogin-footer__logo-ldp-container">
               <img src="static/img/ldp-logo_lion.svg" alt="Lions Digital Pro" class="relogin-footer__logo-ldp-image">
               <div class="relogin-footer__logo-ldp-text-container">
                 <div class="relogin-footer__logo-ldp-text">{{ $t('login.work_tech') }}</div>
                 <img src="static/img/ldp-logo_text_white.svg" alt="Lions Digital Pro" class="relogin-footer__logo-ldp-name">
               </div>
             </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    </ui-scrollbar>
  </div>
</template>

<script>
  import Authenticate from 'src/components/Authenticate/Authenticate.vue'
  import config from '@/config'
  import {
    CONF_CLIENT_SITE_LINK,
    CONF_CLEINT_LOGO_PREFIX,
    CONF_GET_ACCOUNT_TEXT,
    CONF_FORGET_PASSWORD_TEXT,
    LANG
  } from '@/constants'
  import LangCheck from 'src/components/Langs/LangCheck.vue'

  export default {
    name: 'ReloginOnFly',
    components: {
      Authenticate,
      LangCheck
    },
    mounted () {
      if (document.querySelectorAll('body > .el-select-dropdown.el-popper[style*="position: absolute"]')[0]) {
        document.querySelectorAll('body > .el-select-dropdown.el-popper[style*="position: absolute"]')[0].style.display = 'none';
      }
      if (document.querySelectorAll('body > .el-popover.el-popper')[0]) {
        document.querySelectorAll('body > .el-popover.el-popper')[0].style.display = 'none';
      }

      const clientId = this.$route.query.clientId || this.$route.query.client_id || this.loginTo3

      switch (clientId) {
        case this.loginTo1:
          this.clientData(1, this.$t('login.login_types.type1'))
          break
        case this.loginTo2:
          this.clientData(2, this.$t('login.login_types.type2'))
          break
        case this.loginTo3:
          this.clientData(3, this.$t('login.login_types.type3'))
          break
        case this.loginTo4:
          this.clientData(4, this.$t('login.login_types.type4'))
          break
        case this.loginTo5:
          this.clientData(5, this.$t('login.login_types.type5'))
          break
        case this.loginTo6:
          this.clientData(3, this.$t('login.login_types.type6'))
          break
        case this.loginTo7:
          this.clientData(6, this.$t('login.login_types.type7'))
          break
        case this.loginTo8:
          this.clientData(7, this.$t('login.login_types.type8'))
          break
        case this.loginTo9:
          this.clientData(8, this.$t('login.login_types.type9'))
          break
        case this.loginTo10:
          this.clientData(3, this.$t('login.login_types.type10'))
          break
        case this.loginTo11:
          this.clientData(9, this.$t('login.login_types.type11'))
          break
        case this.loginTo12:
          this.clientData(9, this.$t('login.login_types.type12'))
          break
        case this.loginTo13:
          this.clientData(9, this.$t('login.login_types.type13'))
          break
      }
    },
    data () {
      return {
        showLoginHelp: false,
        validationError: '',
        alertText: '',
        alertType: 'success',
        notificationText: '',
        createAccText: '',
        clientLink: config(CONF_CLIENT_SITE_LINK),
        clientLogoPrefix: config(CONF_CLEINT_LOGO_PREFIX),
        getAccountText: config(CONF_GET_ACCOUNT_TEXT) || null,
        forgetPasswordText: config(CONF_FORGET_PASSWORD_TEXT) || null,
        infoType: 0,
        loginTo1: config('APPLICANT_PERSONAL_CABINET'),
        loginTo2: config('APPLICANT_DOCUMENTS_SUBMISSION'),
        loginTo3: config('APPLICANT_NOTIFICATIONS'),
        loginTo4: config('STUDENT_PERSONAL_CABINET'),
        loginTo5: config('STUDENT_DISTANCE_LEARNING'),
        loginTo6: config('STUDENT_NOTIFICATIONS'),
        loginTo7: config('STUDENT_RECORD_CYCLES'),
        loginTo8: config('EMPLOYEE_PERSONAL_CABINET'),
        loginTo9: config('EMPLOYEE_SYSTEM_ANTIPLAGIATE'),
        loginTo10: config('EMPLOYEE_NOTIFICATIONS'),
        loginTo11: config('ELIB_STUDENT_CONSULTANT'),
        loginTo12: config('ELIB_DOCTOR_CONSULTANT'),
        loginTo13: config('ELIB_MEGAPRO'),
        loginTypeSrc: null,
        loginTypeText: null
      }
    },
    computed: {
      lang () {
        return this.$store.state.lang
      },
      logoSrc () {
        return `static/img/logos/${this.clientLogoPrefix}_login_${this.lang}.svg`;
      },
      logoSrcDefault () {
        return `static/img/logos/${this.clientLogoPrefix}_login_en.svg`;
      },
      footerLogoSrc () {
        return `static/img/logos/${this.clientLogoPrefix}_white_new_${this.lang}.svg`;
      },
      footerLogoSrcDefault () {
        return `static/img/logos/${this.clientLogoPrefix}_white_new_en.svg`;
      }
    },
    methods: {
      clientData (loginTypeLogo, loginTypeText) {
        this.loginTypeSrc = `/static/img/login_type${loginTypeLogo}.svg`
        this.loginTypeText = loginTypeText
      },
      onShowCreateAcc () {
        this.infoType = 1;
        this.createAccText = this.getAccountText[this.lang.toUpperCase()] || this.getAccountText.EN;
        this.showLoginHelp = !this.showLoginHelp
      },
      onShowForgotPassword () {
        this.infoType = 2;
        this.createAccText = this.forgetPasswordText[this.lang.toUpperCase()] || this.forgetPasswordText.EN;
        this.showLoginHelp = !this.showLoginHelp
      },
      onRecoveryCodeSended () {
        // this.notificationText = this.$t('login.notifications.recover_email');
      },
      onPasswordChanged () {
        // this.alertText = this.$t('login.notifications.password_changed');
      },
      onLoginCancel () {
        this.$emit('login-canceled')
        this.$bus.$emit('relogin-on-fly:canceled', 'cancel')
      },
      onLoginError () {
        this.$bus.$emit('relogin-on-fly:error')
      },
      onLoginSuccess (token) {
        this.$emit('login-success')
        this.$bus.$emit('relogin-on-fly:success', token)

        this.$bus.$emit('userInfoUprate')
        this.$root.$emit('focusOnContent')
      },
      updateSidebar () {},
      showError (err) {
        this.validationError = err;
      }
    },
    watch: {
      lang (val) {
        if (this.infoType === 1) {
          this.createAccText = this.getAccountText[val.toUpperCase()] || this.getAccountText.EN;
        } else if (this.infoType === 2) {
          this.createAccText = this.forgetPasswordText[val.toUpperCase()] || this.forgetPasswordText.EN;
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../assets/sass/core";

$screen-sm:           768px;
$screen-md:           992px;
$screen-lg:           1200px;
$max-container-width: $screen-lg;

.relogin-on-fly {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 999;
  background: rgba(57, 124, 255, 0.2);
  .bz-scrollbar__content--wrapper {
    display: flex;
    flex-direction: column;
  }

  &__lang-check.el-dropdown {
    position: absolute;
    right: 25px;
    top: 20px;
  }

  &__content-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  &__ie-blur {
    // display: none;
    position: absolute;
    // opacity: .7;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: #f0a02d url('/static/img/background/login-page_background_new.jpg') center / cover no-repeat;
  }

  &__inner {
    z-index: 1;
    position: relative;
    max-width: 460px;
    width: 100%;
    padding: 27px 15px;
  }

  &__form-container {
    position: relative;
    z-index: 1;
    background: #fff;
    border-radius: 10px;
  }

  &__alert {
    background: #CEF2DB;
    padding: 25px 60px;
    font-size: 14px;
    color: #15BF51;
    margin-bottom: 10px;
    border-radius: 10px;
  }

  &__notify {
    position: relative;
    margin-bottom: 15px;
    padding: 24px 20px 25px 80px;
    background: #FEEDC2;
    box-shadow: 0px 14px 24px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    font-size: 15px;
    line-height: 1.3;
    color: #F3AF37;

    @media only screen and (min-width: $screen-sm){
      padding: 24px 60px 25px 100px;
    }
  }

  &__icon {
    display: flex;
    align-content: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    position: absolute;
    top: 24px;
    left: 15px;
    padding: 15px;
    border-radius: 100%;
    text-align: center;
    background-color: rgba(242, 180, 72, 0.31);

    @media only screen and (min-width: $screen-sm){
      left: 30px;
    }
  }

  .form {
    padding: 0 20px 30px 20px;
    @media only screen and (min-width: $screen-sm){
      padding: 0 60px 51px 60px;
    }

    .login-page-form__logo + & {
      padding-top: 40px;
    }
  }

  &__legend {
    padding: 30px 20px 25px 20px;
    color: #2B2927;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;

    @media only screen and (min-width: $screen-sm){
      padding: 30px 60px 23px 60px;
    }

    &-title {
      white-space: nowrap;
    }

    .client_logo {
      margin: 0 10px;
    }

    .client_text {
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      color: #616161;
      white-space: normal;
      max-width: 140px;
    }
  }

  &__notification {
    display: block;
    width: 100%;
    margin-top: -35px;
    padding: 10px 20px;
    border-radius: 2px;
    background: #CEF2DB;
    font-size: 12px;
    font-weight: 400;
    color: #15BF51;

    @media only screen and (min-width: $screen-sm){
      margin-top: 0;
    }
  }

  &__error {
    display: block;
    width: 100%;
    margin-top: -35px;
    padding: 10px 20px;
    border-radius: 2px;
    background: #FF5656;
    font-size: 12px;
    font-weight: 400;
    color: #fff;

    @media only screen and (min-width: $screen-sm){
      margin-top: 0;
    }
  }
}

.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter {
  opacity: 0;
}

.relogin-header {
  height: 75px;
  width: 100%;
  z-index: 1;
  position: relative;
  background: #fff;

  &__container {
    display: flex;
    height: 100%;
    justify-content: flex-start;
    align-items: center;
    padding: 0 25px;

    @media only screen and (min-width: $screen-lg) {
      max-width: $max-container-width;
      margin: 0 auto;
    }
    @media (max-width: 480px) {
      padding-left: 12px;
    }
  }

  &__logo {
    height: 100%;
    display: flex;
    align-items: center;
  }

  &__logo-img {
    margin-right: 5px;
    position: relative;
    top: 5px;
  }

  &__logo-text {
    display: inline-block;
    margin: 0;
    font-weight: 700;
    font-size: 14px;
    color: #1E5A9F;
    max-width: 165px;
    line-height: 1.1;
  }
}

.relogin-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
}

.relogin-footer {
  width: 100%;
  position: relative;
  z-index: 1;

  &__wrapper {
    @media only screen and (min-width: $screen-lg) {
      height: 100%;
      max-width: $max-container-width;
      margin: 0 auto;
      padding: 0 25px;
    }
  }

  &__container {
    display: grid;
    align-items: center;
    grid-template-areas:
    "logo"
    "text"
    "logo-ldp";
    border-top: 1px solid rgba(252, 252, 252, .2);

    @media only screen and (min-width: $screen-md) {
      grid-template-areas:
      "logo text logo-ldp";
    }
  }

  &__logo {
    grid-area: logo;
    display: block;
    padding: 25px;
    box-sizing: border-box;
    text-align: center;

    @media only screen and (min-width: $screen-lg) {
      padding: 10px 0;
      text-align: left;
    }

    img {
      max-width: 218px;
      max-height: 76px;
    }
  }

  &__text {
    grid-area: text;
    text-align: center;
    color: #fff;
    font-size: 16px;
  }

  &__link {
    padding: 0 0 25px 25px;

     @media only screen and (min-width: $screen-sm){
       border-bottom: 1px solid rgba(252, 252, 252, .2);
       padding: 25px 0 25px 25px;
     }

     @media only screen and (min-width: $screen-md){
       border-bottom: none;
     }

     @media only screen and (min-width: $screen-lg) {
       padding-left: 0;
     }

     &:nth-of-type(2){
       grid-area: link-1;
     }

     &:nth-of-type(3){
       grid-area: link-2;
     }

     &:nth-of-type(4){
       grid-area: link-3;
     }
  }

  &__link-title {
    opacity: .5;
    font-size: 10px;
    color: #fff;
    font-weight: 400;
  }

  &__link-link {
    font-size: 21px;
    font-weight: 700;
    color: #fff;
    line-height: 1;

    &:hover {
      opacity: .8;
      color: #fff;
    }
  }

  &__logo-ldp {
    grid-area: logo-ldp;
    display: block;
    padding: 25px;
    // border-top: 1px solid rgba(252, 252, 252, .2);
    img {
      max-width: 100%;
    }

    @media only screen and (min-width: $screen-sm) {
      border-top: none;
    }

    @media only screen and (min-width: $screen-lg) {
      justify-self: end;
      padding-left: 0;
      padding-right: 0;
    }
  }

  &__logo-ldp-container {
    display: flex;
    justify-content: center;
  }

  &__logo-ldp-text-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__logo-ldp-image {
    margin-right: 13px;
  }

  &__logo-ldp-text {
    opacity: .5;
    font-size: 10px;
    margin-bottom: 5px;
    color: #fff;
    font-weight: 400;
  }
}
</style>